// extracted by mini-css-extract-plugin
export default {"reviews":"productsDetailReviews_reviews__xKhcs"};